import { render, staticRenderFns } from "./ListRequestLogPage.vue?vue&type=template&id=62c36cae"
import script from "./ListRequestLogPage.vue?vue&type=script&lang=js"
export * from "./ListRequestLogPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports